import { FormEvent, useState } from 'react';
import { Organization, createOrganization, updateOrganization } from '../../../api/accessApi';
import { useAsync } from './shared';

export default function OrganizationsTab({ orgs, onChanged }: { orgs: Organization[]; onChanged: () => void }) {
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const { error, busy, run } = useAsync();

  const add = async (e: FormEvent) => {
    e.preventDefault();
    const created = await run(() => createOrganization({ name: name.trim(), code: code.trim() || undefined }));
    if (created) {
      setName('');
      setCode('');
      onChanged();
    }
  };

  const toggleActive = async (o: Organization) => {
    const updated = await run(() => updateOrganization(o.id, { is_active: !o.is_active }));
    if (updated) onChanged();
  };

  return (
    <section className="panel">
      <h2>Organizations</h2>
      {error && <p className="acc-error">{error}</p>}
      <form className="acc-form acc-inline" onSubmit={add}>
        <label>
          Name
          <input required minLength={2} value={name} onChange={(e) => setName(e.target.value)} />
        </label>
        <label>
          Code
          <input value={code} onChange={(e) => setCode(e.target.value)} />
        </label>
        <button className="btn primary" disabled={busy}>
          Add organization
        </button>
      </form>
      <div className="acc-scroll">
        <table className="acc-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {orgs.map((o) => (
              <tr key={o.id} className={o.is_active ? '' : 'acc-off'}>
                <td>
                  <b>{o.name}</b>
                </td>
                <td>{o.code ?? ''}</td>
                <td>{o.is_active ? 'Active' : 'Inactive'}</td>
                <td className="acc-actions">
                  <button className="btn" disabled={busy} onClick={() => toggleActive(o)}>
                    {o.is_active ? 'Deactivate' : 'Activate'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {orgs.length === 0 && <p className="note">No organizations yet.</p>}
      </div>
    </section>
  );
}
